module.exports = __webpack_public_path__ + "img/secondary-fill.1af34232.svg";